import { css, styled } from "styled-components";

interface ModalProps {
  $width?: string | number;
  $height?: string | number;
}

export const Modal = styled.div<ModalProps>`
  ${props =>
    props.$width
    && css`
      width: ${typeof props.$width === "number" ? `${props.$width}px` : props.$width} !important;
    `};
  ${props =>
    props.$height
    && css`
      height: ${typeof props.$height === "number" ? `${props.$height}px` : props.$height} !important;
    `};
`;
